import React from 'react';
import { Avatar, ListItem, FontIcon } from 'material-ui';
import pluralize from 'pluralize';
import R from 'ramda';

const CompanyWithLocs = ({ profileImageUrl, companyName, locations }) => {
  return (
    <ListItem
      leftAvatar={profileImageUrl ? <Avatar src={profileImageUrl}/> : <Avatar>{R.head(companyName || '')}</Avatar>}
      primaryText={`${companyName} : ${R.length(locations)} ${pluralize('location', R.length(locations))}`}
      nestedItems={
        locations.map(({ name, locationId }) => (
          <ListItem
            key={locationId}
            primaryText={name}
            leftIcon={<FontIcon className="tc-icon-location_on" />}
          />
        ))
      }
    />);
};

export default CompanyWithLocs;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/ownerMetaDataPages/displayCompanyWithLocs.jsx